
import { AdminAccountService, DavisAlertService, BookService } from '@DavisDigital/davisdigitalfrontend.module';

class AdminAvailableLicenseController {
	public availableLicenses:any = [];
	public fetchingLicenses: boolean = false;
	
	// @ngInject
	constructor(
		 private adminAccountService:AdminAccountService,
		 private davisAlertService:DavisAlertService,
		 private bookService: BookService
	){}
	
	public $onInit = () => {
		this.fetchingLicenses = true;
		//load license information
		this.adminAccountService.getLicenseData().then(res => {
			this.availableLicenses = res.data.unassignedLicenses;
		}).finally(() => {
			this.fetchingLicenses = false;
		});
	}
	
	public isSampleBook = (bookCode) => this.bookService.isSampleBook(bookCode);
	
}

class AdminAvailableLicense {
	public restrict: string = 'E';
	public templateUrl: string;
	public scope: boolean = true;
	
	public bindToController: any = {};

	public controller = AdminAvailableLicenseController;
	public controllerAs = 'adminAvailableLicense';

	public static Factory() {
		var directive:any = ( davisFrontendBasePath ) => new this( davisFrontendBasePath );
		directive.$inject = ['davisFrontendBasePath'];
		return directive;
	}

	constructor(
		private davisFrontendBasePath
	) {
		this.templateUrl = davisFrontendBasePath + '/davisdigital/directives/admin-available-license.html';
	}
}

export { AdminAvailableLicense };
